const ChecboxWithSpan = ({inStyle, parentStyle, childStyle, name, inType, inputStyle, value, title}) => {
    return (<span style={inStyle}>
        <span class={parentStyle}>
            <input type={inType} name={name} class={inputStyle} value={value} />
            <span class={childStyle}></span>
        </span> {title}</span>)
}
export default ChecboxWithSpan